import React, { useEffect, useState } from 'react'
import * as Styled from './InstagramPosts.styled'
import { Row, Column } from '@zera-admin/page'

import Analysis from '../../components/analysis'
import { InstagramCard } from '../../components/instagram-card'

import { InstagramPostsProps } from './types'

import UpdateButton from '../../components/update-button/UpdateButton'
import { PostInstagram } from '../../widgets/types'
import WidgetLayout from '../../widgets/widget-layout'
import { AnalysisData } from '../../components/analysis/types'

import { useFlagcardContext } from 'app/contexts/flagcard'
import { getAgendaReportInstagram } from 'services/http/report/agenda-report-4/endpoint'

const InstagramPosts: React.FC<InstagramPostsProps> = ({
  date,
  isEditValue,
  setIsEditValue,
  pageNumber,
  title,
  data,
  metaData,
}) => {
  const [postData, setPostData] = useState<PostInstagram | undefined>(data)
  const [videoId, setVideoId] = useState<string | undefined>('')

  const [pageData, setPageData] = useState<{
    title: string
    pageNumber: number
  }>({ title: title, pageNumber: pageNumber })

  const [editMode, setEditMode] = useState<boolean>(false)

  const [flagCard] = useFlagcardContext()

  useEffect(() => {
    if (isEditValue === pageNumber) {
      setEditMode(true)
    }
  }, [isEditValue, pageNumber])

  useEffect(() => {
    if (isEditValue === -1) {
      setPostData(data)
      setPageData({ title: title, pageNumber: pageNumber })
    }
  }, [isEditValue, data, title, pageNumber])

  const handleDeleteVideo = () => {
    setPostData(undefined)
  }

  const addVideo = () => {
    getAgendaReportInstagram({
      GroupId: metaData?.GroupId,
      ShortCode: videoId,
    })
      .then((res) => {
        setPostData(res.data.data)
      })
      .catch((err) => {
        console.log(err)
        flagCard.add({
          appearance: 'error',
          title: 'Bir hata oluştu',
          children:
            'Veritabanında post bulunamadı. Lütfen posy short code bilgisini kontrol ediniz.',
        })
      })
  }

  const onChange = (key: string, value: string) => {
    postData && setPostData({ ...postData, [key]: value })
  }

  const onChangePageData = (key: string, value: string) => {
    setPageData({
      ...pageData,
      [key]: value,
    })
  }

  const editProps = {
    isEditValue: isEditValue,
    setIsEditValue: setIsEditValue,
    pageNumber: pageData.pageNumber,
    metaData,
  }

  return (
    <WidgetLayout
      asideDate={date}
      asideTitle={pageData.title}
      pageNumber={pageData.pageNumber}
      onChange={onChangePageData}
      editMode={editMode}
      flagShortCode={metaData?.flagShortCode}
    >
      <Styled.InstagramAnalysisWrapper>
        <UpdateButton
          {...editProps}
          contentData={{
            Post: postData,
          }}
          title={pageData.title}
          editMode={editMode}
          setEditMode={setEditMode}
        />

        <Styled.InstagramAnalysisContainer>
          <Row xs={{ justify: 'center' }}>
            {postData ? (
              <Column
                className="instagram"
                xs={{ size: postData?.Analysis ? 7 : 8 }}
              >
                <InstagramCard
                  data={postData}
                  editmode={editMode}
                  onChange={onChange}
                />
                {editMode && (
                  <button
                    className="delete-instagram"
                    onClick={handleDeleteVideo}
                  >
                    X
                  </button>
                )}
              </Column>
            ) : (
              <Column xs={{ size: 8 }}>
                <div className="add-instagram">
                  <input
                    type="text"
                    placeholder="Post Short Code Giriniz"
                    onChange={(e) => setVideoId(e.target.value)}
                  />
                  <button onClick={addVideo}>Post Ekle</button>
                </div>
              </Column>
            )}

            {postData?.Analysis && (
              <Column xs={{ size: 5 }}>
                <Analysis
                  editMode={editMode}
                  onChange={onChange}
                  data={postData as AnalysisData}
                />
              </Column>
            )}
          </Row>
        </Styled.InstagramAnalysisContainer>
      </Styled.InstagramAnalysisWrapper>
    </WidgetLayout>
  )
}

export default InstagramPosts
